import React from 'react'
import { currency } from 'lib/utils/string'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { calculateStripeFee } from 'lib/stripe'
import { useStyles } from './styles'
import { flags, useFeatureFlags } from 'lib/feature-flags'

const TransactionSummary = ({ title, priceInCents, cardBrand, lastDigits }) => {
  const [isStripeFlatFeeDeducted] = useFeatureFlags([
    flags.FLAT_FEAT_STRIPE_FEE_DEDUCTED,
  ])
  const priceInDollars = priceInCents ? priceInCents / 100 : null
  const processingFeeInDollars = isStripeFlatFeeDeducted
    ? 0
    : calculateStripeFee(priceInCents || 0) / 100

  const classes = useStyles()

  return (
    <>
      <Typography variant="h5" style={{ marginTop: '36px' }}>
        Transaction summary
      </Typography>
      <Box mb={1} mt={2} className={classes.infoRow}>
        <Typography variant="body1" className={classes.lighterText}>
          {title}
        </Typography>
        <Typography variant="body1" className={`${classes.lighterText}`}>
          {currency(priceInDollars + processingFeeInDollars)}
        </Typography>
      </Box>
      <Box mb={1} className={classes.infoRow}>
        <Typography variant="body1" className={classes.fontBolded}>
          Total
        </Typography>
        <Typography variant="body1" className={`${classes.fontBolded}`}>
          {currency(priceInDollars + processingFeeInDollars)}
        </Typography>
      </Box>
      <Box mb={3} className={classes.infoRow}>
        <Typography variant="body1">Payment information</Typography>
        <Typography variant="body1">
          Paid with {cardBrand} card ************{lastDigits}
        </Typography>
      </Box>
      <Divider className={classes.dividerStyles} />
    </>
  )
}

export default TransactionSummary
